import { Group, Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";

interface SectionBlockProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

export function SectionBlock({ title, description, actions, children }: SectionBlockProps) {
  return (
    <Stack gap="var(--axio-unit-16)" className="sectionBlock">
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
        <Stack gap="var(--axio-unit-6)">
          <Title order={4}>{title}</Title>
          {description != null && (
            <Text size="sm" c="dimmed">
              {description}
            </Text>
          )}
        </Stack>
        {actions}
      </Group>
      {children}
    </Stack>
  );
}
